import React from 'react';
import PropTypes from 'prop-types';

import { Switch } from '@companycam/slab-web';
import { translate } from 'translations/i18n';

const ShowTagsToggle = ({ showTags, setShowTags }) => {
  return (
    <Switch
      id="show-tags-toggle"
      label={translate('assetFeed.viewMenu.showTagsToggle.title')}
      pressed={showTags}
      onClick={() => {
        setShowTags(!showTags);
      }}
      data-testid="view_menu__show-tags"
    />
  );
};

ShowTagsToggle.propTypes = {
  showTags: PropTypes.bool.isRequired,
  setShowTags: PropTypes.func.isRequired,
};

export default ShowTagsToggle;
